import React from "react";
import type { PackType } from "../../../../../../common-deprecated/types/CommonTypes";
import * as FormStyles from "../../../../../../common-deprecated/styles/v2/toyota/components/Form";
import * as Styles from "./styles/StandardFinancePackEquipment";
import useFinancePackConfigurables from "../../../hooks/shared/financepacks/useFinancePackConfigurables";
import Price from "../common/price/Price";
import { useBnbSelector } from "../../../redux/store";
import type { FinancePackConfigurablesType } from "../../../../../shared-logic/types/FinanceTypes";

export type StandardFinancePackEquipmentType = {
    equipment: FinancePackConfigurablesType;
    pack: PackType;
};

const StandardFinancePackContent = (props: StandardFinancePackEquipmentType): JSX.Element => {
    const { equipment, pack } = props;
    const { isChecked, onChange } = useFinancePackConfigurables(equipment, pack);
    const financeOption = useBnbSelector((state) => state.utils.financeOption);

    return (
        <Styles.Wrapper hasBorder={financeOption === "cash"}>
            <FormStyles.Checkbox my={0}>
                <input
                    id={equipment.id}
                    type="checkbox"
                    checked={equipment.standard ? true : isChecked}
                    onChange={() => {
                        onChange(isChecked);
                    }}
                    disabled={equipment.standard}
                />
                <label htmlFor={equipment.id}>{equipment.name}</label>
            </FormStyles.Checkbox>
            {equipment.price && <Price price={equipment.price} />}
        </Styles.Wrapper>
    );
};

export default StandardFinancePackContent;
